import {provideRouter, Route, Router} from "@angular/router";
import {AppComponent} from "./app/app.component";
import {bootstrapApplication} from "@angular/platform-browser";
import {provideStore} from "@ngrx/store";
import {
  APP_INITIALIZER,
  ErrorHandler,
  importProvidersFrom,
  isDevMode,
  provideZonelessChangeDetection
} from "@angular/core";
import {metaReducers, reducers} from "./app/state/app.state";
import {provideEffects} from "@ngrx/effects";
import {HomeEffects} from "./app/state/home/home.effects";
import {HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi} from "@angular/common/http";
import {StoreDevtoolsModule} from "@ngrx/store-devtools";
import {TokenInterceptor} from "./app/service/token.interceptor.service";
import {ToastModule} from "primeng/toast";
import {MessageService} from "primeng/api";
import {BrowserAnimationsModule} from "@angular/platform-browser/animations";
import {TimelineModule} from "primeng/timeline";
import * as Sentry from '@sentry/angular';
import {getApiBaseUrl} from "src/app/config/api";
import pk from 'package.json';
import {provideServiceWorker} from '@angular/service-worker';

declare global {
  interface Window {
    /** Boot watchdog installed by the inline script in index.html. */
    __otBootWatchdog?: { ok: () => void; fail: (reason?: unknown) => void };
  }
}

const appRoutes: Route[] = [{
  path: "",
  loadComponent: () => import("./app/components/tracking-home/tracking-home.component")
    .then((m) => m.TrackingHomeComponent),
}];

const baseURL = getApiBaseUrl();

const sentry = {
  dsn: 'https://39bdeee55d2cfb535b4a9ba3ed09f4c3@o1302573.ingest.sentry.io/4505799741931520',
  env: baseURL.replace('https://', ''),
};

Sentry.init({
  dsn: sentry.dsn,
  release: `${pk.name}@${pk.version}`,
  environment: window.location.host,
  enabled: !window.location.host.includes('localhost'),
  integrations: [
    Sentry.httpContextIntegration(),
    Sentry.browserTracingIntegration(),
    Sentry.browserApiErrorsIntegration()
  ],
});

bootstrapApplication(AppComponent, {
  providers: [
    provideZonelessChangeDetection(),
    provideHttpClient(withInterceptorsFromDi()),
    provideRouter(appRoutes),
    provideStore(reducers, {metaReducers}),
    provideEffects([HomeEffects]),
    provideServiceWorker('ngsw-worker.js', {
      enabled: !isDevMode(),
    }),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true
    },
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler({
        showDialog: false,
        logErrors: true,
      }),
    },
    {
      provide: Sentry.TraceService,
      deps: [Router],
    },
    {
      provide: APP_INITIALIZER,
      useFactory: () => () => {
      },
      deps: [Sentry.TraceService],
      multi: true,
    },
    MessageService,
    importProvidersFrom([
      BrowserAnimationsModule,
      ToastModule,
      TimelineModule,
    ]),
    ...(isDevMode() ? [importProvidersFrom(StoreDevtoolsModule.instrument({
      name: pk.name,
      maxAge: 25,
      logOnly: false,
      autoPause: true,
      trace: true,
      traceLimit: 75,
    }))] : []),
  ]
}).then(() => {
  // Disarms the boot watchdog installed in index.html.
  window.__otBootWatchdog?.ok();
}).catch((err) => {
  console.error(err);
  window.__otBootWatchdog?.fail(err);
})
